import ErrorContainer from './ErrorContainer';

export {
  ErrorContainer
}

export default ErrorContainer;
